import { useEffect } from "react";
import { reportError } from "../../../lib/bugReporting";
import styles from "./CloseToolConfirmationModal.module.css";
import WarningModal from "../../common/modals/WarningModal/WarningModal";

const strings = {
  cancel: "Stay on Page",
  closeTool: (isPlural: boolean) => `Close Tool${isPlural ? "s" : ""}`,
  messageLine1: (isPlural: boolean) =>
    ` ${isPlural ? "are" : "is"} in progress.`,
  messageLine2: (isPlural: boolean) =>
    `Are you sure you want to close ${isPlural ? "these tools" : "this tool"} and lose all progress?`,
  closeToolConfirmationModal: "Close Tool Confirmation Modal",
};

type Props = {
  isOpen: boolean;
  toolNames: string[];
  onCloseTool: () => void;
  onRequestClose: () => void;
};
const CloseToolConfirmationModal = ({
  isOpen,
  toolNames,
  onCloseTool,
  onRequestClose,
}: Props) => {
  useEffect(() => {
    if (isOpen && toolNames.length === 0) {
      reportError(
        new Error(
          "Error: Attempted to open CloseToolConfirmationModal without any active tools",
        ),
      );
    }
  }, [isOpen, toolNames.length]);

  if (isOpen && toolNames.length === 0) {
    return null;
  }

  const multipleTools = toolNames.length > 1;
  let toolNameListString = "";
  if (multipleTools) {
    const toolsExceptLastToolNames = toolNames.slice(0, -1);
    toolNameListString = `${toolsExceptLastToolNames.join(
      ", ",
    )} and ${toolNames.slice(-1)}`;
  } else {
    toolNameListString = toolNames[0];
  }

  return (
    <WarningModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      modalLabel={strings.closeToolConfirmationModal}
      body={
        <>
          <div>
            <span className={styles.toolNameText}>{toolNameListString}</span>
            {strings.messageLine1(multipleTools)}
          </div>
          <div>{strings.messageLine2(multipleTools)}</div>
        </>
      }
      closeText={strings.cancel}
      confirmText={strings.closeTool(multipleTools)}
      onConfirm={onCloseTool}
    />
  );
};
export default CloseToolConfirmationModal;
